import { render } from "./StatisticsPublicVisitsCountByTimeTab.vue?vue&type=template&id=6bb4d73e&ts=true"
import script from "./StatisticsPublicVisitsCountByTimeTab.vue?vue&type=script&lang=ts"
export * from "./StatisticsPublicVisitsCountByTimeTab.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__